var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92448 8.59074C4.33453 8.18069 4.99935 8.18069 5.4094 8.59074L14.0003 17.1816L22.5911 8.59074C23.0012 8.18069 23.666 8.18069 24.076 8.59074C24.4861 9.00079 24.4861 9.66561 24.076 10.0757L14.7427 19.409C14.3327 19.819 13.6679 19.819 13.2578 19.409L3.92448 10.0757C3.51443 9.66561 3.51443 9.00079 3.92448 8.59074Z",
    fill: "#FF7B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.f78db84922b9ad9cf3ef6cf70bd83929.svg";
export { ForwardRef as ReactComponent };